import { IconFont } from '@/components/IconFont'
import { projectContext } from '@/layouts/MainLayout'
import { getInvitationFailed, deleteInvitation } from '@/services/member/member'
import { Invitation } from '@/services/member/member.model'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { textIncludes } from '@/utils/utils'
import { useRequest } from 'ahooks'
import { Col, Input, Row, Table, Modal, Button } from 'antd'
import Column from 'antd/lib/table/Column'
import classnames from 'classnames'
import dayjs from 'dayjs'
import { memo, useContext, useMemo, useState } from 'react'

export default memo(function ProjectFailedInvitations() {
  const { projectId, projectType } = useContext(projectContext)
  const { data: invitations = [], run: getInvitations, loading } = useRequest(() =>
    getInvitationFailed(projectType, Number(projectId))
  )
  const [filterValue, setFilterValue] = useState('')
  const filterInvitations = useMemo(() => {
    return invitations.filter((invitation) => textIncludes(invitation.email, filterValue))
  }, [invitations, filterValue])

  return (
    <div className={classnames('p-2')}>
      <Row justify={'end'}>
        <Col>
          <Input
            value={filterValue}
            placeholder='Search'
            className={'mr-1'}
            style={{ width: '200px' }}
            prefix={<IconFont type={'icon-search'} />}
            onChange={(event) => {
              const value = event.target.value
              setFilterValue(value)
            }}
          />
        </Col>
      </Row>

      <div className={classnames('mt-2')}>
        <Table
          bordered size='small'
          dataSource={filterInvitations}
          rowKey={(record) => record.id}
          loading={loading}
        >
          <Column title='Email' dataIndex='email' key='email' align={'center'} />

          <Column
            title='Create time'
            dataIndex='createTime'
            key='createTime'
            align={'center'}
            render={(value) => dayjs(value).format('MMM D, YYYY')}
          />

          <Column
            title='Operation'
            dataIndex='title'
            key='title'
            align={'center'}
            render={(_, record: Invitation.Pending) => (
              <Button
                size={'small'}
                onClick={() => {
                  Modal.confirm({
                    icon: <ExclamationCircleOutlined />,
                    content: 'Are you sure to delete?',
                    onOk: async () => {
                      await deleteInvitation(record.id)
                      getInvitations()
                    }
                  })
                }}
              >
                <IconFont type='icon-shanchu' />
              </Button>
            )}
          />
        </Table>
      </div>
    </div>
  )
})
